'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiFlowSwitch = function TiFlowSwitch(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm13.3 27v-1.2c0-1.4 0.9-2.6 2.2-3.4-1.1-0.4-2.2-1.1-3.1-1.9-1.5 1.4-2.4 3.3-2.4 5.3v1.2c-1.9 0.7-3.3 2.5-3.3 4.7 0 2.7 2.2 5 5 5s5-2.3 5-5c0-2.2-1.4-4-3.4-4.7z m-1.6 6.3c-1 0-1.7-0.7-1.7-1.6s0.7-1.7 1.7-1.7 1.6 0.7 1.6 1.7-0.7 1.6-1.6 1.6z m15-20.3v0.6c0 1.7-0.9 3.1-2.3 3.9 1.1 0.5 2.2 1.1 3.1 1.9 1.5-1.5 2.5-3.5 2.5-5.8v-0.6c1.9-0.7 3.3-2.5 3.3-4.7 0-2.7-2.2-5-5-5s-5 2.3-5 5c0 2.2 1.4 4 3.4 4.7z m1.6-6.3c1 0 1.7 0.7 1.7 1.6s-0.7 1.7-1.7 1.7-1.6-0.7-1.6-1.7 0.7-1.6 1.6-1.6z m1.6 20.2c-0.7-4.8-4.9-8.6-9.9-8.6-3.2 0-5.9-2.3-6.5-5.3 1.8-0.7 3.2-2.5 3.2-4.7 0-2.7-2.3-5-5-5s-5 2.3-5 5c0 2.2 1.4 4.1 3.4 4.8 0.7 4.8 4.9 8.6 9.9 8.6 3.2 0 5.9 2.3 6.5 5.3-1.8 0.7-3.2 2.5-3.2 4.7 0 2.7 2.3 5 5 5s5-2.3 5-5c0-2.2-1.4-4.1-3.4-4.8z m-18.2-20.2c0.9 0 1.6 0.7 1.6 1.6s-0.7 1.7-1.6 1.7-1.7-0.7-1.7-1.7 0.7-1.6 1.7-1.6z m16.6 26.6c-0.9 0-1.6-0.7-1.6-1.6s0.7-1.7 1.6-1.7 1.7 0.7 1.7 1.7-0.7 1.6-1.7 1.6z' })
        )
    );
};

exports.default = TiFlowSwitch;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/flow-switch.js
// module id = 3634
// module chunks = 0